import React from 'react'

import { Text } from 'recharts'

import { Stack, Typography, Box, Fade, useTheme } from '@mui/material'

// import { Icon }  from 'lucide-react'

type EmptyStateProps = {
  title?: string
  text?: string,
  icon?: React.ReactNode
  buttons?: React.ReactNode,
  sx?: object
}

export const EmptyState = ({ title, text, icon, buttons, sx }: EmptyStateProps) => {
    const theme = useTheme()
    return (
        <Fade in={true} timeout={300}>
            <Stack spacing={3} 
                sx={{ 
                    maxWidth: '100%', 
                    height: '100%', 
                    pb: title == undefined ? 0 : 10, 
                    display: "flex", 
                    alignItems:"center", 
                    justifyContent:"center", 
                    ...sx
                }}>
                <Box sx={{ width: 72, height: 72, borderRadius: '50%', backgroundColor: theme.palette.primary[50], display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    {icon}
                </Box>
                {title && (
                    <Typography variant="body2" pt={3}>
                        {title}
                    </Typography>  
                )} 
                {text && (
                    <Typography 
                        sx={{maxWidth: 400, textAlign: "center", lineHeight: 1.5}} 
                        variant="body3" 
                        color={title == undefined ? "text.primary" : "text.secondary"} 
                        pb={4}>
                        {text}
                    </Typography>
                )}
                {buttons && buttons}
            </Stack>
        </Fade>
    )
}
